import { encryptContent, EncryptionActionType } from '../../../../app/actions/spaces/EncryptContentAction';
import { AppState } from '../../../../app/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { IDataSourceDetailInfo } from '../../../../datasource/models/IDataSourceInfo';
import { IEncryptAction } from '../../../../ts/ServerApi/types/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isVisibleOnEncryptionAction } from './IEntityActionHelpers';

export const EncryptAction: IEntityAction<IContentInfo, IEncryptAction> = {
  name: EntityActionNames.Encrypt,
  translateName: Messages.encrypt_action,
  isVisible: (targetItems: IContentInfo[], state: AppState) => {
    return isVisibleOnEncryptionAction(targetItems as IDataSourceDetailInfo[], state);
  },
  isClickable: (availableActions: IEncryptAction, targetItems: IContentInfo[]) => {
    return targetItems.length > 1 || !!(availableActions && availableActions.encryptExtracts);
  },
  createReduxAction: (targetItems: IContentInfo[]) => encryptContent(targetItems, EncryptionActionType.encryptExtracts)
};
